import { render, staticRenderFns } from "./CheckoutIntegrationForm.vue?vue&type=template&id=36cbf3b0"
import script from "./CheckoutIntegrationForm.vue?vue&type=script&lang=ts"
export * from "./CheckoutIntegrationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports